export const getToken = () => localStorage.getItem('speakiq_token');
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('speakiq_user') || 'null');
  } catch { return null; }
};

export const setAuth = (token, user) => {
  localStorage.setItem('speakiq_token', token);
  localStorage.setItem('speakiq_user', JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem('speakiq_token');
  localStorage.removeItem('speakiq_user');
};

export const isLoggedIn = () => !!getToken();
export const getUserRole = () => getUser()?.role;
